import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ShowComponent } from '@/common/component/show.component';

import { TouristGuide } from './tourist-guides.model';

@Component({
	selector: 'app-tourist-guides',
	templateUrl: './tourist-guides.component.html',
	styleUrls: ['./tourist-guides.component.css'],
})
export class TouristGuidesComponent extends ShowComponent implements OnInit {
	data: TouristGuide = {
		id: null,
		firstName: null,
		lastName: null,
		birthdate: null,
		phonePrivate: null,
		phoneBusiness: null,
		emailPrivate: null,
		emailBusiness: null,
		nearest_city: null,
		chronically_ill: 0,
		type: null,
		rate: null,
		comments: null,
		salaryComments: null,
		userId: null,
	};
	errors = {};
	cities: Array<any> = [];
	types = [];
	users: Array<any> = [];
	filteredUsers: Array<any> = [];
	userControl = new FormControl<any>(null);
	apiUrlAdd = '/symfony/tourist-guide';
	selectedTabIndex = 0;
	protected itemsBeforeDataLoad = 3;
	protected parentComponent = 'touristGuides';
	private readonly tabNames = ['basic', 'rates', 'salary'];

	get isSalaryTab(): boolean {
		return this.tabNames[this.selectedTabIndex] === 'salary';
	}

	getApiUrl(): string {
		return '/symfony/tourist-guide/' + this.data.id;
	}

	protected override afterLoadData(): void {
		this.filteredUsers = [...this.users];
		if (this.data.userId) {
			const found = this.users.find((u) => u.id === this.data.userId);
			if (found) this.userControl.setValue(found, { emitEvent: false });
		}
		if (this.pageFunction !== 'add' && !this.editable) {
			this.userControl.disable();
		}
		this.userControl.valueChanges.subscribe((val) => {
			if (typeof val === 'string') {
				const q = val.toLowerCase();
				this.filteredUsers = this.users.filter((u) =>
					`${u.firstName} ${u.lastName} ${u.email}`.toLowerCase().includes(q),
				);
				if (!val) this.data.userId = null;
			}
		});
	}

	override editUnlock(): void {
		super.editUnlock();
		this.userControl.enable();
	}

	displayUser = (user: any): string => {
		if (!user) return '';
		return `${user.firstName} ${user.lastName} | ${user.email}`;
	};

	onUserSelected(user: any): void {
		this.data.userId = user?.id ?? null;
	}

	protected override doAdd(): void {
		this.api.post(this.apiUrlAdd, this.submitConvert(this.data), (result, error) => {
			if (!error) {
				this.data.id = result.data.id;
			}
			this.afterSend(result, error);
		});
	}

	override ngOnInit(): void {
		super.ngOnInit();

		this.route.queryParams.subscribe((params) => {
			const tabParam = params['tab'];
			if (tabParam) {
				const tabIndex = this.tabNames.indexOf(tabParam);
				if (tabIndex !== -1) {
					this.selectedTabIndex = tabIndex;
				}
			}
		});
	}

	onTabChange(index: number): void {
		this.selectedTabIndex = index;
		this.router.navigate([], {
			relativeTo: this.route,
			queryParams: { tab: this.tabNames[index] },
			queryParamsHandling: 'merge',
		});
	}

	protected loadBefore() {
		this.api.get('/nearestBigCity/', (result, error) => {
			this.cities = result.data;
			this.loadData();
		});

		this.api.get('/touristGuideTypes/', (result, error) => {
			this.types = result.data;
			this.loadData();
		});

		this.api.get('/users/', (result, _error) => {
			this.users = result.data;
			this.loadData();
		});
	}

	protected pageTitleGenerate(): string {
		return 'Edycja: ' + this.data.firstName + ' ' + this.data.lastName;
	}
}
